import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import { GetLocalStorageByKey } from "../Utils/BaseUtils";

// Layout per le pagine private (con autenticazione)
const AuthenticatedLayout = (props: any) => {
    const onlyBodyBool = GetLocalStorageByKey('onlybody');

    //const onlyBody = props.onlyBody;
    return onlyBodyBool ? (
        <div className={props.class}>
            {props.children}
        </div >
    ) : (
        <div className={props.class}>
        <Header />
        {props.children}
        {/* <Footer /> */}
    </div >
    )
};

export default AuthenticatedLayout;